const tableCellEquip = {
  cellHaveChecklist: 'Sí',
  cellNotHaveChecklist: 'No',
}

export default tableCellEquip;